import { render, staticRenderFns } from "./SubjectDialog.vue?vue&type=template&id=1a3151ad&scoped=true&"
import script from "./SubjectDialog.ts?vue&type=script&lang=ts&"
export * from "./SubjectDialog.ts?vue&type=script&lang=ts&"
import style0 from "./SubjectDialog.scss?vue&type=style&index=0&id=1a3151ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3151ad",
  null
  
)

export default component.exports